export default __webpack_public_path__ + "slices/main/assets/public/podcast-subscribe-toggle/stitcher.77ad7b952ccb0107d1f2d2d699b92a8e.svg";